import React, { useState, useRef } from "react";
import { Navigate, Link } from "react-router-dom";
import Lottie from 'lottie-react';
import form from '../json/form.json';
import configuration from '../config/configuration.json';
import axios from 'axios';
import PhoneNumberInput from '../components/PhoneNumberInput'; // Importa el nuevo componente

const Register = () => {
    // Uso de useState para manejar el estado
    const [logged, setLogged] = useState(false);
    const [mailCheck, setMailCheck] = useState(true);
    const [passCheck, setPassCheck] = useState(false);
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [ruc, setRuc] = useState("");
    const [stablishment, setStablishment] = useState("");
    const [stablishmentDirection, setStablishmentDirection] = useState("");
    const [stablishmentDepartment, setStablishmentDepartment] = useState("");
    const [stablishmentTelephone, setStablishmentTelephone] = useState("");
    const [stablishmentCode, setStablishmentCode] = useState("");
    const [telephone, setTelephone] = useState("");
    const [cellphone, setCellphone] = useState(""); // Este es el campo que cambiaremos
    const [direction, setDirection] = useState("");
    const [department, setDepartment] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [whatsappNotification, setWhatsappNotification] = useState(false);
    const [emailNotification, setEmailNotification] = useState(false);

    // Uso de useRef para acceder a elementos del DOM
    const mensajeBtnRef = useRef(null);
    const mensajeEmailRef = useRef(null);
    const mensajePasswordRef = useRef(null);
    const snackbarMsjRef = useRef(null);
    const snackbarBoxRef = useRef(null);

    const handlerMail = (e) => {
        if (mensajeBtnRef.current) mensajeBtnRef.current.innerText = " ";
        setEmail(e.target.value);
        const regEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(e.target.value);

        if (mensajeEmailRef.current) {
            if (regEx) {
                mensajeEmailRef.current.innerText = " ";
                setMailCheck(true);
            } else {
                mensajeEmailRef.current.innerText = "Ingrese un mail válido";
                setMailCheck(false);
            }
        }
    };

    const handlerWhatsappCheckBox = () => {
        setWhatsappNotification(prev => !prev); // Alterna el valor booleano
    };

    const handlerMailCheckBox = () => {
        setEmailNotification(prev => !prev); // Alterna el valor booleano
    };

    const handlerPass = (e) => {
        if (mensajeBtnRef.current) mensajeBtnRef.current.innerText = " ";
        setPassword(e.target.value);
        const regEx = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/.test(e.target.value);

        if (mensajePasswordRef.current) {
            // Nota: Aquí tenías `if(true)` en tu código original, lo que siempre hacía la contraseña válida.
            // Lo he corregido para usar `regEx`.
            if (regEx) {
                mensajePasswordRef.current.innerText = " ";
                setPassCheck(true);
            } else {
                mensajePasswordRef.current.innerText = "más de 8 letras, más de 1 dígito, más de 1 mayúscula.";
                setPassCheck(false);
            }
        }
    };

    // Nuevo handler para el campo de celular, usará el valor sanitizado de PhoneNumberInput
    const handleCellphoneChange = (sanitizedValue) => {
        setCellphone(sanitizedValue);
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        if (mensajeBtnRef.current) mensajeBtnRef.current.innerText = " ";

        if (mailCheck && passCheck) {
            try {
                const res = await fetch(process.env.REACT_APP_URL_API + configuration.REGISTER, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "accept": "text/plain"
                    },
                    body: JSON.stringify({
                        name,
                        lastName,
                        businessName,
                        ruc,
                        stablishment,
                        stablishmentDirection,
                        stablishmentDepartment,
                        stablishmentTelephone,
                        stablishmentCode,
                        telephone,
                        cellphone, // Usamos el estado del cellphone
                        direction,
                        department,
                        email,
                        status: 'ACTIVO',
                        password,
                        whatsappNotification,
                        emailNotification
                    }),
                });
                const data = await res.json();

                if (snackbarMsjRef.current && snackbarBoxRef.current) {
                    if (data.status === 'Error') {
                        snackbarMsjRef.current.innerText = data.data;
                        snackbarBoxRef.current.classList.add("snackbar-hd", "snackbar-error");
                        setTimeout(() => {
                            snackbarBoxRef.current.classList.remove("snackbar-hd", "snackbar-error");
                        }, 3000);
                    } else {
                        snackbarMsjRef.current.innerText = data.data;
                        snackbarBoxRef.current.classList.add("snackbar-hd");
                        setTimeout(() => { snackbarBoxRef.current.classList.remove("snackbar-hd"); }, 3000);

                        const formData = new FormData();
                        let contentData = [
                            { "key": "Nombre", "value": name },
                            { "key": "Apellido", "value": lastName },
                            { "key": "Establecimiento", "value": stablishment },
                            { "key": "RUC", "value": ruc },
                            { "key": "Correo Electrónico", "value": email },
                            { "key": "Departamento", "value": department },
                            { "key": "Celular", "value": cellphone }, // Enviamos el celular sanitizado
                        ];

                        formData.append("subject", "Registro de usuario");
                        formData.append("content", JSON.stringify(contentData));
                        formData.append("isForEmail", true);
                        formData.append("toEmail", "web-registro@elrodeo.com.py");
                        formData.append("formType", "Registro_usuario");
                        formData.append("files", []);

                        axios.post(configuration.PANEL_SERVER_URL + configuration.POST_SUBMIT_FORM, formData)
                            .then((response) => {
                                if (response.data.status === "error") {
                                    console.error("Ocurrió un error al enviar el correo");
                                }
                            })
                            .catch((error) => {
                                if (error.name === "AxiosError") {
                                    console.error(error);
                                }
                            });

                        setLogged(true);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        } else {
            if (mensajeBtnRef.current) mensajeBtnRef.current.innerText = "Complete correctamente los campos de arriba.";
        }
    };

    return (
        <div className="form-m form-m-register">
            {logged ? (<Navigate to="/login" />) : null}
            <div className="form">
                <Lottie
                    animationData={form}
                    loop={false}
                    className="form_img"
                />
                <form onSubmit={onSubmit}>
                    <br />
                    <br />
                    <h3>Registrate</h3>
                    <div className="form_box">
                        <div className="form_flex">
                            <div>
                                <div className="form_box_item">
                                    <label>Nombre *</label><br />
                                    <input
                                        type="text"
                                        className="input_wide"
                                        id='name'
                                        name='name'
                                        onChange={(e) => setName(e.target.value)}
                                        value={name} // Controlar el input con el estado
                                    />
                                </div>

                                <div className="form_box_item">
                                    <label>Apellido *</label><br />
                                    <input
                                        type="text"
                                        className="input_wide"
                                        id='lastName'
                                        name='lastName'
                                        onChange={(e) => setLastName(e.target.value)}
                                        value={lastName}
                                    />
                                </div>
                                <div className="form_box_item">
                                    <label>Email *</label><br />
                                    <input
                                        type="email"
                                        className="input_wide"
                                        id='email'
                                        name='email'
                                        autoComplete="on"
                                        onChange={handlerMail}
                                        value={email}
                                    />
                                    <small id="mensajeEmail" ref={mensajeEmailRef}></small>
                                </div>
                                <div className="form_box_item">
                                    <label>Contraseña *</label><br />
                                    <input
                                        type="password"
                                        className="input_wide"
                                        id='pass'
                                        name='pass'
                                        autoComplete="on"
                                        onChange={handlerPass}
                                        value={password}
                                    />
                                    <small id="mensajePassword" ref={mensajePasswordRef}></small>
                                </div>
                            </div>
                            <div>
                                <div className="form_box_item">
                                    <label>RUC *</label><br />
                                    <input
                                        type="text"
                                        className="input_wide"
                                        id='ruc'
                                        name='ruc'
                                        autoComplete="on"
                                        onChange={(e) => setRuc(e.target.value)}
                                        value={ruc}
                                    />
                                </div>
                                <div className="form_box_item">
                                    <label>Celular *</label><br />
                                    {/* Aquí reemplazamos el input estándar por nuestro componente PhoneNumberInput */}
                                    <PhoneNumberInput
                                        value={cellphone}
                                        onChange={handleCellphoneChange}
                                    />
                                </div>
                                <div className="form_box_item">
                                    <label>Departamento</label><br />
                                    <input
                                        type="text"
                                        className="input_wide"
                                        id='department'
                                        name='department'
                                        autoComplete="on"
                                        onChange={(e) => setDepartment(e.target.value)}
                                        value={department}
                                    />
                                </div>
                                <div className="form_box_item">
                                    <label>Establecimiento</label><br />
                                    <input
                                        type="text"
                                        className="input_wide"
                                        id='stablishment'
                                        name='stablishment'
                                        autoComplete="on"
                                        onChange={(e) => setStablishment(e.target.value)}
                                        value={stablishment}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="cajasCheckbox">
                            <p>¿Quiere recibir notificaciones?</p>
                            <br />

                            <input
                                className="checkbox"
                                type="checkbox"
                                id='Whatsapp'
                                name='Whatsapp'
                                autoComplete="on"
                                checked={whatsappNotification} // Controlar el estado del checkbox
                                onChange={handlerWhatsappCheckBox}
                            />
                            <label className="register_checkbox_label">Whatsapp</label><br />

                            <br />

                            <input
                                className="checkbox"
                                type="checkbox"
                                id='Mail'
                                name='Mail'
                                autoComplete="on"
                                checked={emailNotification} // Controlar el estado del checkbox
                                onChange={handlerMailCheckBox}
                            />
                            <label className="register_checkbox_label">Mail</label><br />
                        </div>

                    </div>

                    <button type="submit" onClick={onSubmit} className="btn btn_cta">Registrate</button>
                    <small id="mensajeBtn" ref={mensajeBtnRef}></small>
                </form>
            </div>
            <p className="form_passwordReset">¿Necesitas migrar tu cuenta anterior? Haga <Link to="/migrar"><span>click aqui</span></Link></p>
            {/* Elementos para el Snackbar */}
            <div id="snackbar_box" ref={snackbarBoxRef}>
                <span id="snackbar_msj" ref={snackbarMsjRef}></span>
            </div>
        </div>
    );
};

export default Register;
